import { useTypedParams } from '@sorare/routing';

import { WatchlistsLayout } from '@sorare/marketplace/src/components/watchlists/WatchlistsLayout';

import { AppLayout } from '#src/components/navigation/AppLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

export const WatchlistLayout = () => {
  const { id } = useTypedParams<LayoutParams>();

  return (
    <AppLayout>
      <WatchlistsLayout id={id} />
    </AppLayout>
  );
};

export default WatchlistLayout;
